'use client';

import { c as _c } from "react/compiler-runtime";
import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import prev from '@images/renders/architecture_images/leftArrow.svg';
import next from '@images/renders/architecture_images/rightArrow.svg';
import cn from 'classnames';
import NextImage from 'next/image';
import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from '../../AboutForma.module.scss';
const AboutFormaSlider = t0 => {
  const $ = _c(22);
  const {
    slidesData
  } = t0;
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const swiperRef = useRef();
  const leftRef = useRef();
  const rightRef = useRef();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handlePrev() {
      if (swiperRef.current) {
        swiperRef.current.slidePrev();
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handlePrev = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function handleNext() {
      if (swiperRef.current) {
        swiperRef.current.slideNext();
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleNext = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (swiperRef.current) {
        setIsBeginning(swiperRef.current.isBeginning);
        setIsEnd(swiperRef.current.isEnd);
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const updateNavigationState = t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (swiperRef.current) {
        swiperRef.current.on("slideChange", updateNavigationState);
        swiperRef.current.on("reachBeginning", updateNavigationState);
        swiperRef.current.on("reachEnd", updateNavigationState);
        swiperRef.current.on("fromEdge", updateNavigationState);
        updateNavigationState();
      }
    };
    t5 = [];
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn(styles.ninthScreenGallery, styles.ninthScreenImagesBox);
    t7 = swiper => {
      swiperRef.current = swiper;
      updateNavigationState();
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] !== slidesData) {
    t8 = slidesData.map(_temp);
    $[7] = slidesData;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t8) {
    t9 = <div>{t8}</div>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== isBeginning) {
    t10 = !isBeginning && <div ref={leftRef} className={styles.prev} onClick={handlePrev} role="button" tabIndex="0"><NextImage className={styles.arrow} src={prev} alt="arrow-previous" /></div>;
    $[11] = isBeginning;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div />;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== isEnd) {
    t12 = !isEnd && <div ref={rightRef} className={styles.next} onClick={handleNext} role="button" tabIndex="0"><NextImage className={styles.arrow} src={next} alt="arrow-next" /></div>;
    $[14] = isEnd;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t10 || $[17] !== t12) {
    t13 = <div className={styles.nav}>{t10}{t11}{t12}</div>;
    $[16] = t10;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t9) {
    t14 = <Swiper ref={swiperRef} className={t6} onSwiper={t7} slidesPerView="auto" allowTouchMove={true}>{t9}{t13}</Swiper>;
    $[19] = t13;
    $[20] = t9;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
};
export default AboutFormaSlider;
function _temp(slide, index) {
  return <SwiperSlide key={`${slide.title}-${index}`} className={slide.desktopClass}><div className={styles.ninthScreenCardTitle}>{slide.title}</div><ParallaxMedia src={slide.img} src375={slide.img375} name="image" imagePlug={slide.imgPlug} className={styles.ninthScreenImgInner} /></SwiperSlide>;
}